import * as React from 'react'

import { F0Card } from '@factorialco/f0-react'
import { UpsellGlpButton, UpsellGlpCard } from 'generated/resources/datatable.graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

interface GlpCardBlockProps {
  block: UpsellGlpCard
}

export const GlpCardBlock: React.FC<GlpCardBlockProps> = ({ block }) => {
  if (!block) {
    return null
  }

  const cardMedia = block?.cardMedia?.url || block?.cardMedia?.url || ''

  const secondaryActions = block.actions?.map((action: UpsellGlpButton) => ({
    label: action.label || '',
    onClick: () => {
      track(trackingEvents.discover.clickGlpButton, {
        component: 'glp_card',
        action: action.label,
      })
    },
  }))

  return (
    <F0Card
      key={block?.id}
      image={cardMedia}
      title={block?.cardTitle || ''}
      description={block?.cardContent || ''}
      secondaryActions={secondaryActions}
    />
  )
}
